(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/react/components/select-charity-header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/react/components/select-charity-header.js');

'use strict';

const ScrollToHash = svs.tb_ui_react.scroll_to_hash.ScrollToHash;
const SelectCharityHeader = _ref => {
  let {
    className = ''
  } = _ref;
  return React.createElement("div", {
    className: className
  }, React.createElement(ScrollToHash, {
    hash: "charity"
  }), React.createElement("p", {
    className: "f-800 margin-bottom-2 align-center"
  }, "Vill du bidra till en god sak?"), React.createElement("p", {
    className: "align-left"
  }, "H\xE4r kan du v\xE4lja att st\xF6tta en ideell organisation med 10% av din insats. Det kostar allts\xE5 inget extra och har ingen p\xE5verkan \xF6ver dina vinstchanser. Du v\xE4ljer helt enkelt bara att spela f\xF6r en god sak."));
};
setGlobal('svs.lyckoplatsen.components.shared_charity.react.components', {
  SelectCharityHeader
});

 })(window);